import React from 'react';


const AuthorizeDevice = () => (
  <div className="content">
    <div className="container">
      <div className="well">
        <div className="row-r">
          <div className="col-sm-12">
            <h1>Authorize Your Computer</h1>
            <p className="medium-text">
              We don't recognize the web browser or
              computer that you're accessing the site
              from. In order to keep your account secure,
              we restrict certain areas of the site to
              access from authorized sources only.
            </p>
            <p className="medium-text">
              We've already started the authorization
              process. An email has been sent to the
              address configured in your account. The
              email contains a code that you need to copy
              and paste into the box below. This will
              complete the authorization process for this
              web browser. Accessing the site from another
              browser or device (a computer, phone, or
              tablet for example) will require a separate
              authorization.
            </p>
          </div>
          <div className="col-sm-4">
            <form
              acceptCharset="UTF-8"
              action="/account/devices"
              method="post"
            >
              <input
                defaultValue="✓"
                name="utf8"
                type="hidden"
              />
              <input
                defaultValue="XkdnqcZ1erq5mLEPP/25zG9LHjhULt4gvkkIAS0+0b9aszCWnnen2nClbICuw3FPIpSzJOSatLmMOxzg/nR6pA=="
                name="authenticity_token"
                type="hidden"
              />
              <h4>Enter Authorization Code</h4>
              <input
                className="form-control"
                defaultValue={true}
                id="code"
                name="code"
                style={{
                  display: 'block',
                  marginBottom: '.5em',
                }}
                type="text"
              />
              <button
                className="btn btn-success"
                type="submit"
              >
                Authorize My Computer
              </button>
            </form>
          </div>
          <div className="col-sm-4">
            <form
              acceptCharset="UTF-8"
              action="/account/devices/resend"
              method="post"
            >
              <input
                defaultValue="✓"
                name="utf8"
                type="hidden"
              />
              <input
                defaultValue="XkdnqcZ1erq5mLEPP/25zG9LHjhULt4gvkkIAS0+0b9aszCWnnen2nClbICuw3FPIpSzJOSatLmMOxzg/nR6pA=="
                name="authenticity_token"
                type="hidden"
              />
              <h4>I Didn't Get the Email</h4>
              <button
                className="btn btn-warning"
                type="submit"
              >
                Resend Authorization Email
              </button>
            </form>
          </div>
          <div className="col-sm-4">
            <h4>I Still Need Help</h4>
            <a className="btn btn-danger" href="/contact">
              Contact Customer Service
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AuthorizeDevice;
